<div class="card">
  <div class="card-header">
    <h1 class="card-title">{{ 'DASHBOARD' | translate }}</h1>
    <app-alert-indicator />
  </div>
  <app-nav-tab class="dashboard-tabs" size="small" [tabs]="tabs()" />
  <div class="card-content">
    <router-outlet></router-outlet>
  </div>
</div>
<div class="create-link-request-wrapper">
  <button
    app-button
    class="create-link-request"
    variant="primary"
    iconPath="assets/img/add-white.svg"
    [title]="'ATTACH_ALREADY_ACTIVATED_GATEWAY' | translate"
    (click)="onLinkRequestClick()"
  >
    <span class="link-request-label">{{ 'ATTACH_ALREADY_ACTIVATED_GATEWAY' | translate }}</span>
  </button>
</div>
<app-maintenance-period-card [period]="maintenancePeriod()" />
<div class="favorite-list">
  <app-favorite-list />
</div>

<app-link-request-modal [open]="linkRequestModalOpen()" (closed)="linkRequestModalOpen.set(false)" />
